import React from 'react';
// src/components/Toaster.jsx
import { GD } from '../constants';

function Toaster({ toasts }) {
  return (
    <div style={{ position:'fixed', bottom:80, left:'50%', transform:'translateX(-50%)', zIndex:9999, display:'flex', flexDirection:'column', gap:8, alignItems:'center', pointerEvents:'none' }}>
      {toasts.map(t => (
        <div key={t.id} style={{
          padding:'12px 22px', borderRadius:30, fontWeight:700, fontSize:14,
          letterSpacing:0.3, maxWidth:320, textAlign:'center',
          background: t.type==='error' ? '#F6465D' : t.type==='warn' ? GD : '#0ECB81',
          color: t.type==='warn' ? '#0D0A00' : 'white',
          boxShadow:'0 8px 32px rgba(0,0,0,0.5)',
          animation:'slideUp 0.3s ease'
        }}>{t.message}</div>
      ))}
    </div>
  );
}

export default React.memo(Toaster);
